import { Suspense } from "react";
import { Route, Routes } from "react-router";
import {
  PATH_ABOUT,
  PATH_CONTACT,
  PATH_PORTFOLIO,
  PATH_SERVICE,
  PATH_SERVICE_DETAIL,
  PATH_TECHNOLOGY,
} from "../../utility/constants";
import Contact from "../contact";
import HomePage from "../home";
import "./index.css";
import Technology from "../technology";
import Services from "../services";
import ServiceDetail from "../serviceDetail";
import About from "../about";
import Portfolio from "../portfolio";

const DefaultLayout = () => {
  return (
    <div className="layout_container">
      {/* <AppHeader />
      <div className="layout_mid_container"> */}
      <Suspense>
        <Routes>
          <Route index element={<HomePage />} />
          <Route path={`${PATH_TECHNOLOGY}/:tech`} element={<Technology />} />
          <Route path={PATH_SERVICE} element={<Services />} />
          <Route
            path={`${PATH_SERVICE_DETAIL}/:service`}
            element={<ServiceDetail />}
          />
          <Route path={PATH_PORTFOLIO} element={<Portfolio />} />
          <Route path={PATH_ABOUT} element={<About />} />
          <Route path={PATH_CONTACT} element={<Contact />} />
        </Routes>
      </Suspense>
      {/* </div> */}
    </div>
  );
};

export default DefaultLayout;
